import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Wallet from './components/Wallet';
import HowToUse from './components/HowToUse';
import Screenshots from './components/Screenshots';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';

function HashScroller() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      return;
    }
    const id = location.hash.slice(1);
    const frame = window.requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [location]);

  return null;
}

function Home() {
  return (
    <main id="contenu">
      <Hero />
      <Features />
      <Wallet />
      <HowToUse />
      <Screenshots />
      <Contact />
    </main>
  );
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="App">
        <a className="skip-link" href="#contenu">
          Aller au contenu
        </a>
        <HashScroller />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/privacy"
            element={(
              <main id="contenu">
                <PrivacyPolicy />
              </main>
            )}
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
